import { render } from "./ControlliEstrattoBanca.vue?vue&type=template&id=3ebcacfa"
import script from "./ControlliEstrattoBanca.vue?vue&type=script&lang=js"
export * from "./ControlliEstrattoBanca.vue?vue&type=script&lang=js"

import "./ControlliEstrattoBanca.vue?vue&type=style&index=0&id=3ebcacfa&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__